export interface StaminaState {
  current: number;
  max: number;
  /** Whether the player is actively sprinting this frame (drives "show the bar" + colour). */
  active: boolean;
}
type Listener = (s: StaminaState) => void;

/**
 * Client-only stamina mirror (see docs/design/character-stats.md). Stamina is a runtime resource
 * computed in world3d's per-frame loop; the HUD bar subscribes here. Not synced or persisted.
 */
class StaminaStore {
  private state: StaminaState = { current: 100, max: 100, active: false };
  private readonly listeners = new Set<Listener>();

  get(): StaminaState { return this.state; }

  set(current: number, max: number, active: boolean): void {
    this.state = { current, max, active };
    for (const fn of this.listeners) fn(this.state);
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.state);
    return () => this.listeners.delete(fn);
  }
}

export const staminaStore = new StaminaStore();
